import ScopeActions from './scope-actions';
// reducer with initial state
const initialState = {
	scopes: [],
	scopeData: {},
	newScope: {},
	updatedScope: {},
	clientsLinkToScopeData: [],
	updatedClientsLinkToScope: false
};
export default function scopeReducer(state = initialState, action) {
	switch (action.type) {
		case ScopeActions.API_GET_SCOPE_DATA_SUCCESS:
			return { ...state, scopeData: action.payload };
		case ScopeActions.API_GET_SCOPES_DATA_SUCCESS:
			return { ...state, scopes: action.payload };
		case ScopeActions.API_POST_SCOPE_DATA_SUCCESS:
			return { ...state, newScope: action.payload };
		case ScopeActions.API_PUT_SCOPE_DATA_SUCCESS:
			return { ...state, updatedScope: action.payload };
		case ScopeActions.API_CLEAR_SCOPE_DATA:
			return { ...state, newScope: {}, scopeData: {}, updatedScope: {}, updatedClientsLinkToScope: false };
		case ScopeActions.API_GET_CLIENTS_LINK_TO_SCOPE_SUCCESS:
			return { ...state, clientsLinkToScopeData: action.payload?._embedded?.clients };
		case ScopeActions.API_PUT_CLIENTS_LINK_TO_SCOPE_SUCCESS:
			return { ...state, updatedClientsLinkToScope: true };
		case ScopeActions.API_CLEAR_CLIENTS_LINK_TO_SCOPE:
			return { ...state, clientsLinkToScopeData: [] };
		default:
			return state;
	}
}
